export default "__VITE_ASSET__UNSp0ItC__"